import { useQuery } from '@tanstack/react-query';
import { getBalance, GetBalanceReturnType } from '@wagmi/core';
import { useAccount } from 'wagmi';

import { wagmiConfig } from '@/lib/wagmi/config';
import { useAccountStore } from '@/store/use-account-store';
import { getUSDCAddress } from '@/utils/addresses';

type Props = {
  disabled?: boolean;
  chainId?: number;
};

const defaultBalance: GetBalanceReturnType = {
  value: 0n,
  decimals: 0,
  symbol: '',
  formatted: '',
};

export const getEvmBalanceQueryKey = (chainId?: number, address?: string) => [
  'evm/balance/usdc',
  chainId,
  address,
];

export default function useEvmBalance({
  disabled,
  chainId: defaultChainId,
}: Props = {}) {
  const { chainId: wagmiChainId } = useAccount();
  const address = useAccountStore((state) => state.address as `0x${string}`);
  const chainId = defaultChainId ?? wagmiChainId;
  const enabled = !disabled && !!address && chainId !== undefined;

  const queryKey = getEvmBalanceQueryKey(chainId, address);

  const { data, ...query } = useQuery({
    queryKey,
    queryFn: () => {
      if (!address) return defaultBalance;
      return getBalance(wagmiConfig, {
        address,
        blockTag: 'latest',
        token: getUSDCAddress(chainId as number),
      });
    },
    enabled,
  });

  return {
    ...(!data || !data.symbol.endsWith('USDC') ? defaultBalance : data),
    ...query,
    queryKey,
  };
}
